import { fetchGraphQL } from 'core/services/graphQLservice'

// getMoveAndReviewDetailsByCustomer(customerID:"${CID}")
export async function getCustomerDetails(CID: string, customerToken:string) {
//debugger;
    var params = `query{
        getCustomerDetails(customerID:"${CID}", customerToken:"${customerToken}")
        {
            customerID
            moveID
            moveDailySheetID
            estimatorID
            customerName
            customerDetails
            estimatorDetails
            branchDetails
            origin
            destination
            customerEmail
            customerAdd1
            customerAdd2
            customerDestAdd1
            customerDestAdd2
            customerPh
            branchID
            estimatorName
            estimatorVideo
            estimatorPhone
            customerSigFlag
            paymentFlag
            
          }
      }
      `;

    var response = await fetchGraphQL('POST', params);
    return response.data.getCustomerDetails;
}